module.exports = __webpack_public_path__ + "static/img/1033_small.c54f294.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1033_small.png
// module id = D6Ds
// module chunks = 1